<template>
	<v-container fluid>
		<div class="d-flex flex-wrap mb-4" style="gap: 16px">
			<v-card
				width="100%"
				max-width="300"
				outlined
				v-for="topCard in situacionesContratos"
				:key="topCard.text"
				:loading="topCard.value === null"
				v-if="$root.acceso(topCard.acceso)"
			>
				<v-row class="pa-4">
					<v-col cols="auto" class="align-center d-flex">
						<v-avatar rounded="100" color="primary" size="50">
							<v-icon dark v-text="topCard.icon" />
						</v-avatar>
					</v-col>
					<v-col>
						<h2 v-if="topCard.value !== null" v-text="topCard.value + topCard.unit" />
						<span v-text="topCard.texto" />
					</v-col>
				</v-row>
			</v-card>
		</div>

		<v-row>
			<v-col v-if="$root.acceso('VER_CONTRATOS')" cols="12" class="col-md-6">
				<div v-if="!loaded.meses" class="d-flex align-center justify-center">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</div>
				<bar-chart @loaded="loaded.meses = true" />
			</v-col>
			<v-col v-if="$root.acceso('VER_CONTRATOS')" cols="12" class="col-md-6">
				<div v-if="!loaded.donut" class="d-flex align-center justify-center">
					<v-progress-circular indeterminate color="primary"></v-progress-circular>
				</div>
				<doughnut-chart @loaded="loaded.donut = true" />
			</v-col>
			<v-col v-if="$root.acceso('VER_INCIDENCIAS')" cols="12" class="col-md-6">
				<tabla-incidencias />
			</v-col>
			<v-col v-if="$root.acceso('VER_CONTRATOS')" cols="12" class="col-md-6">
				<tabla-ultimos-contratos />
			</v-col>
			<!-- <v-col cols="12" class="col-md-6">
				<tabla-comisionistas />
			</v-col>
			<v-col cols="12" class="col-md-6">
				<tabla-tareas />
			</v-col>
			<v-col cols="12" class="col-md-6">
				<tabla-notificaciones />
			</v-col>-->
		</v-row>
	</v-container>
</template>

<script>
import { processToken, consumosTotalesClientes } from "@/utils/index.js";

export default {
	components: {
		BarChart: () => import("@/components/BarChart.vue"),
		DoughnutChart: () => import("@/components/DoughnutChart.vue"),
		TablaUltimosContratos: () =>
			import("@/components/TablaUltimosContratos.vue"),
		TablaComisionistas: () => import("@/components/TablaComisionistas.vue"),
		TablaTareas: () => import("@/components/TablaTareas.vue"),
		TablaNotificaciones: () => import("@/components/TablaNotificaciones.vue"),
		TablaIncidencias: () => import("@/components/TableIncidencias.vue"),
	},
	data() {
		return {
			loaded: {
				donut: false,
				meses: false,
			},
			situacionesContratos: {
				numeroImpagados: {
					icon: "mdi-currency-eur-off",
					texto: "Impagados",
					value: null,
					unit: "",
					acceso: 'CONTROL_IMPAGADOS',
				},
				totalImpagados: {
					icon: "mdi-currency-eur-off",
					texto: "Monto Impagados",
					value: null,
					unit: "€",
					acceso: 'CONTROL_IMPAGADOS',
				},
				totalClientes: {
					icon: "mdi-account-group",
					texto: "Clientes",
					value: null,
					unit: "",
					acceso: 'VER_CONTRATOS',
				},
				contratosActivos: {
					icon: "mdi-check-all",
					texto: "Contratos Activos",
					value: null,
					unit: "",
					acceso: 'VER_CONTRATOS',
				},
				totalContratos: {
					icon: "mdi-file-document",
					texto: "Altas de Contratos",
					value: null,
					unit: "",
					acceso: 'VER_CONTRATOS',
				},
				// comisiones: {
				// 	icon: "mdi-currency-eur",
				// 	texto: "Comisiones",
				// 	value: null,
				// 	unit: "€",
				// 	acceso: 'VER_CONTRATOS',
				// },
				// deuda: {
				// 	icon: "mdi-currency-eur-off",
				// 	texto: "Deuda",
				// 	value: null,
				// 	unit: "€",
				// 	acceso: 'VER_CONTRATOS',
				// },
				consumos: {
					icon: "mdi-lightning-bolt",
					texto: "Consumos totales",
					value: null,
					unit: "",
					acceso: 'VER_CONTRATOS',
				},
			},
		};
	},
	methods: {
		async getTopCardsInfo() {
			let str = this.$store.getters.getDatosEmpresa;

			// const { IdUsuario, IdAgente } = str.iss;
			// const IdEmpresa = this.$store.getters.getIdEmpresa;
			// axios({
			// 	method: "GET",
			// 	url: `${process.env.VUE_APP_API_URL}/Agente/ResumenTotal/Empresa/${IdEmpresa}/Usuario/${IdUsuario}/Agente/${IdAgente}`,
			// }).then((res) => {
			// 	let temp = processToken(res.data).iss;
			// 	this.situacionesContratos.contratosActivos.value = temp.TotalContratosActivos;
			// 	this.situacionesContratos.totalClientes.value = temp.TotalClientes;
			// 	// this.situacionesContratos.comisiones.value = Number( temp.TotalComision ).toFixed(2);
			// 	// this.situacionesContratos.deuda.value = Number(temp.TotalDeuda).toFixed( 2 );
			// });

			const { IdUsuario, IdAgente } = str.iss;
			const IdEmpresa = this.$store.getters.getIdEmpresa;

			const redondear = (bytes, dp = 3) => {
				const thresh = 1000;

				if (Math.abs(bytes) < thresh) {
					return bytes + " B";
				}

				const units = ["kWh", "MWh", "GWh", "TWh", "PWh", "EWh", "ZWh", "YWh"];
				let u = -1;
				const r = 10 ** dp;

				do {
					bytes /= thresh;
					++u;
				} while (
					Math.round(Math.abs(bytes) * r) / r >= thresh &&
					u < units.length - 1
				);

				return bytes.toFixed(dp) + " " + units[u];
			};

			axios({
				method: "GET",
				url: `${process.env.VUE_APP_OUR_API_URL}/contratosVerificados.php`,
				params: {
					token: this.$store.getters.getJwtEmpresa,
					IdAgente,
					codigoContrato: this.codigoContrato,
				},
			}).then(({ data: contratos }) => {
				this.situacionesContratos.totalContratos.value = contratos.length
				this.situacionesContratos.contratosActivos.value = contratos.filter(c => c.Situacion == 'Activado').length
				this.situacionesContratos.totalClientes.value = [...new Set(contratos.filter(c => c.Situacion == 'Activado').map(c => c.IdCliente))].length
				this.situacionesContratos.consumos.value = redondear(contratos.filter(c => c.Situacion == 'Activado').reduce((a, c) => a + Number(c.ConsumoEstimado), 0) * 1000)
			})

			axios({
				url: `${process.env.VUE_APP_OUR_API_URL}/impagados.php`,
				method: 'GET',
				params: {
					token: this.$store.getters.getJwtEmpresa
				}
			}).then(res => {
				this.situacionesContratos.numeroImpagados.value = res.data.length;
				// console.log(res.data.reduce( (a,b) => Number(a.ImporteTotal) + Number(b.ImporteTotal), 0 ))
				this.situacionesContratos.totalImpagados.value = parseFloat(res.data.reduce((a, b) => a + Number(b.ImporteTotal), 0)).toFixed(2);
			})

			// axios({
			// 	method: "GET",
			// 	url: `${process.env.VUE_APP_API_URL}/Contrato/GetDTOAllContratos/?Contratacion_FinderFiltersContratacionAPIDTO={"IdEmpresa":${IdEmpresa},"IdUsuario":${IdUsuario},"IdAgente":${IdAgente}}`,
			// }).then((res) => {
			// 	this.situacionesContratos.totalContratos.value = processToken(
			// 		res.data
			// 	).iss.length;
			// });

			// this.situacionesContratos.consumos.value = await consumosTotalesClientes();

		},
	},
	mounted() {
		this.getTopCardsInfo();
	},
};
</script>

<style>
.dot-elastic {
	position: relative;
	width: 10px;
	height: 10px;
	border-radius: 5px;
	background-color: var(--v-secondary-base);
	color: var(--v-secondary-base);
	animation: dotElastic 1s infinite linear;
	animation-delay: 125ms;
}
.dot-elastic::before,
.dot-elastic::after {
	content: "";
	display: inline-block;
	position: absolute;
	top: 0;
}

.dot-elastic::before {
	left: -12px;
	width: 10px;
	height: 10px;
	border-radius: 5px;
	background-color: var(--v-secondary-base);
	color: var(--v-secondary-base);
	animation: dotElastic 1s infinite linear;
}

.dot-elastic::after {
	left: 12px;
	width: 10px;
	height: 10px;
	border-radius: 5px;
	background-color: var(--v-secondary-base);
	color: var(--v-secondary-base);
	animation: dotElastic 1s infinite linear;
	animation-delay: 250ms;
}
@keyframes dotElastic {
	0% {
		transform: translateY(0);
	}
	25% {
		transform: translateY(-5px);
	}
	50% {
		transform: translateY(0);
	}
	75% {
		transform: translateY(5px);
	}
	100% {
		transform: translateY(0);
	}
}
</style>